import {Dialog, Transition} from "@headlessui/react";
import {Fragment, useState} from "react";
import {XIcon} from "@heroicons/react/outline";

const navigations = [
    {id: 0, name: 'League of Legends'},
    {id: 1, name: 'VALORANT'},
    {id: 2, name: 'PUBG'},
    {id: 3, name: 'Wild Rift'},
    {id: 4, name: 'Dota 2'}
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Gamebar() {
    const [isSidebarOpened, setSidebarOpened] = useState(false)
    const [game, setGame] = useState(0)

    return (
        <div className="md:ml-64">
            <Transition.Root show={isSidebarOpened} as={Fragment}>
                <Dialog as="div" className="fixed inset-0 z-40 flex md:hidden" onClose={isSidebarOpened}>
                    <Transition.Child
                        as={Fragment}
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75"/>
                    </Transition.Child>
                    <Transition.Child
                        as={Fragment}
                        enter="transition ease-in-out duration-300 transform"
                        enterFrom="-translate-x-full"
                        enterTo="translate-x-0"
                        leave="transition ease-in-out duration-300 transform"
                        leaveFrom="translate-x-0"
                        leaveTo="-translate-x-full"
                    >
                        <div className="relative max-w-xs w-full bg-white pt-5 pb-4 flex-1 flex flex-col">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-in-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in-out duration-300"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="absolute top-0 right-0 -mr-12 pt-2">
                                    <button
                                        type="button"
                                        className="ml-1 flex items-center justify-center h-10 w-10 rounded-full"
                                        onClick={() => setSidebarOpened(false)}
                                    >
                                        <span className="sr-only">Menüyü kapat</span>
                                        <XIcon className="h-6 w-6 text-white" aria-hidden="true"/>
                                    </button>
                                </div>
                            </Transition.Child>
                            <div className="mt-5 flex-1 h-0 overflow-y-auto">
                                <nav className="px-2">
                                    {navigations.map((item) => (
                                        <a
                                            key={item.name}
                                            href="#"
                                            onClick={() => {
                                                setGame(item.id)
                                            }}
                                            className={classNames(
                                                item.id === game
                                                    ? 'bg-gray-100 text-gray-900'
                                                    : 'text-gray-600 hover:bg-gray-50 transition-colors hover:text-gray-900',
                                                "group mb-2 rounded-md py-2 px-2 flex items-center text-base font-medium"
                                            )}
                                        >
                                            {item.name}
                                        </a>
                                    ))}
                                </nav>
                            </div>
                        </div>
                    </Transition.Child>
                    <div className="flex-shrink-0 w-14"/>
                </Dialog>
            </Transition.Root>

            <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
                <div className="border-r border-gray-100 pt-12 flex flex-col flex-grow bg-white overflow-y-auto">
                    <div className="flex-grow mt-6 flex flex-col">
                        <nav className="flex-1 px-2 pb-4">
                            {navigations.map((item) => (
                                <a
                                    key={item.name}
                                    href="#"
                                    onClick={() => {
                                        setGame(item.id)
                                    }}
                                    className={classNames(
                                        item.id === game
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-600 hover:bg-gray-50 transition-colors hover:text-gray-900',
                                        `group mb-2 rounded-md py-2 px-2 flex items-center text-sm font-medium ${item.space ? "mt-6" : ""}`
                                    )}
                                >
                                    {item.name}
                                </a>
                            ))}
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}